import { Tabs as MuiTabs, Tab } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLocales } from 'src/legacy/locales';
import { PATH_DASHBOARD } from 'src/legacy/routes/paths';

import { usePlacementListNavigatorContext } from './PlacementListNavigatorContext';

export const Tabs = () => {
  const navigate = useNavigate();
  const { translate } = useLocales();

  const { currentTab, tabs } = usePlacementListNavigatorContext();

  return (
    <MuiTabs
      onChange={(_, newValue) => {
        navigate(`${PATH_DASHBOARD.placement.list}/${newValue}`);
      }}
      sx={{ mb: 2 }}
      value={currentTab}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.value}
          label={`${translate(tab.label)}`}
          value={tab.value}
        />
      ))}
    </MuiTabs>
  );
};
